import OtherFactorsText from './OtherFactorsText';
import RestrictedPersonText from './RestrictedPersonText';
import TermsAndConditionsText from './TermsAndConditionsText';


const DISCLAIMERS = {
  restrictedPerson: {
    header: 'Restricted Person',
    backLabel: 'Order',
    backTo: '/amount',
    text: RestrictedPersonText,
  },
  otherFactors: {
    header: 'Other Factors',
    backLabel: 'Order Confirmation',
    backTo: '/confirmation',
    text: OtherFactorsText,
  },
  termsAndConditions: {
    header: 'Terms and Conditions',
    backLabel: 'Review Order',
    backTo: '/review-order',
    text: TermsAndConditionsText,
  },
};

const getDisclaimer = viewName => (
  DISCLAIMERS[viewName]
);

export default getDisclaimer;



// WEBPACK FOOTER //
// ./src/components/ExternalInvest/DisclaimerViews/getDisclaimer.js